import { Action } from "@ngrx/store";
import { BreadCrumb } from "app/core/interfaces/bread-crumb";
import { ToolbarSettings } from "app/core/interfaces/toolbar-settings";
import { Form, FormProject } from "app/core/models/form";
import { Submission } from "app/core/models/submission";

export const CLEAR_SPINNER = "[Common] Clear Spinner";
export const FILTER_SCHEDULER = "[Common] Filter Scheduler";
export const GET_ASSETTIMELOGS = "[Common] Get AssetTimeLogs";
export const HIDE_TOOLBAR = "[Common] Hide Toolbar";
export const LOAD_SCHEDULER = "[Common] Load Scheduler";
export const PASS_ASSETTIMELOG_OBJ = "[Common] Pass AssetTimeLog Object";
export const SEND_ASSETTIMELOGS = "[Common] Send AssetTimeLogs";
export const SET_LOWER_TOOLBAR_VISIBILITY =
    "[Common] Set Lower Toolbar Visibility";
export const SET_IS_MOBILE_VIEW = "[Common] Set Is Mobile View";
export const SET_PAGE_TITLE = "[Common] Set Page Title";
export const SET_PROJECT = "[Common] Set Project";
export const SET_FORM = "[Common] Set Form";
export const SHOW_TOOLBAR = "[Common] Show Toolbar";
export const START_SPINNER = "[Common] Start Spinner";
export const STOP_SPINNER = "[Common] Stop Spinner";
export const REFRESH_LIST = "[Common] Refresh List";
export const UPDATE_DATA = "[Common] Update Data";
export const DELETE_DATA = "[Common] Delete Data";
export const SHOW_GRID_ACTIONS = "[Common] Show Grid Actions";
export const SET_SUBMISSIONS = "[Common] Set Submissions";
export const SET_BREADCRUMB = "[Common] Set Breadcrumb";

export class HideToolbarAction implements Action {
    readonly type = HIDE_TOOLBAR;
    constructor(public payload: ToolbarSettings) {}
}

export class ClearSpinnerAction implements Action {
    readonly type = CLEAR_SPINNER;
}

export class SelectPageTitleAction implements Action {
    readonly type = SET_PAGE_TITLE;
    constructor(public payload: string) {}
}

export class SetIsMobileViewAction implements Action {
    readonly type = SET_IS_MOBILE_VIEW;
    constructor(public payload: boolean) {}
}

export class SetLowerToolbarVisibilityAction implements Action {
    readonly type = SET_LOWER_TOOLBAR_VISIBILITY;
    constructor(public payload: boolean) {}
}

export class StartSpinnerAction implements Action {
    readonly type = START_SPINNER;
}

export class StopSpinnerAction implements Action {
    readonly type = STOP_SPINNER;
}

export class LoadScheduler implements Action {
    readonly type = LOAD_SCHEDULER;
    constructor(public payload: boolean) {}
}

export class FilterScheduler implements Action {
    readonly type = FILTER_SCHEDULER;
    constructor(public payload: any) {}
}

export class RefreshList implements Action {
    readonly type = REFRESH_LIST;
    constructor(public payload: any) {}
}

export class UpdateData implements Action {
    readonly type = UPDATE_DATA;
    constructor(public payload: any) {}
}

export class DeleteData implements Action {
    readonly type = DELETE_DATA;
    constructor(public payload: string) {}
}

export class ShowGridActions implements Action {
    readonly type = SHOW_GRID_ACTIONS;
    constructor(public payload: string) {}
}

export class SetSubmissions implements Action {
    readonly type = SET_SUBMISSIONS;
    constructor(public payload: Submission[]) {}
}

export class SetBreadCrumb implements Action {
    readonly type = SET_BREADCRUMB;
    constructor(public payload: BreadCrumb[]) {}
}

export class SetProject implements Action {
    readonly type = SET_PROJECT;
    constructor(public payload: FormProject) {}
}

export class SetForm implements Action {
    readonly type = SET_FORM;
    constructor(public payload: Form) {}
}

export type CommonActions =
    | ClearSpinnerAction
    | FilterScheduler
    | LoadScheduler
    | SelectPageTitleAction
    | SetIsMobileViewAction
    | SetLowerToolbarVisibilityAction
    | StartSpinnerAction
    | StopSpinnerAction
    | RefreshList
    | UpdateData
    | DeleteData
    | ShowGridActions
    | SetSubmissions
    | SetBreadCrumb
    | SetProject
    | SetForm;
